// Generated at build time by tools/gen-license.mjs — do not edit, do not commit.
export const PRIMEUI_LICENSE_KEY = '';
